(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  /* Real store imagery: collection image where available, otherwise the first
     actual product image from that collection. Images were read from this store,
     not generated or substituted with stock artwork. */
  const menuImages = {
    'cakes': {
      src: 'https://cdn.shopify.com/s/files/1/0692/6358/9447/files/birthday-truffle-poster-cake-500-gm.jpg?v=1785598832&width=120',
      alt: 'Birthday Truffle Poster Cake'
    },
    'celebration cakes': {
      src: 'https://cdn.shopify.com/s/files/1/0692/6358/9447/files/birthday-truffle-poster-cake-500-gm.jpg?v=1785598832&width=120',
      alt: 'Birthday Truffle Poster Cake'
    },
    'chocolate cakes': {
      src: 'https://cdn.shopify.com/s/files/1/0692/6358/9447/files/lavish-choco-cream-cake-1-kg.png?v=1785598089&width=120',
      alt: 'Lavish Choco Cream Cake'
    },
    'truffle cakes': {
      src: 'https://cdn.shopify.com/s/files/1/0692/6358/9447/files/ceE5GAgBbg18ub9cvHupheM8M2172ApjuppUh9GZ.jpg?v=1787123597&width=120',
      alt: 'Truffle cake'
    },
    'cheesecakes': {
      src: 'https://cdn.shopify.com/s/files/1/0692/6358/9447/files/nutella-cheesecake-1-kg.jpg?v=1785598421&width=120',
      alt: 'Nutella Cheesecake'
    },
    'bento cakes': {
      src: 'https://cdn.shopify.com/s/files/1/0692/6358/9447/files/Yhtk0JBD4v3uJnklodLmZBCqwuVtUgK6WJLWqlXT.jpg?v=1787123808&width=120',
      alt: 'Bento cake'
    },
    'cake slices': {
      src: 'https://cdn.shopify.com/s/files/1/0692/6358/9447/files/nutella-cheese-cake-slice.jpg?v=1785596968&width=120',
      alt: 'Nutella Cheesecake Slice'
    },
    'desserts': {
      src: 'https://cdn.shopify.com/s/files/1/0692/6358/9447/files/vanilla-dot-cake-set-of-2.jpg?v=1785598919&width=120',
      alt: 'Vanilla dessert cake'
    },
    'gifting': {
      src: 'https://cdn.shopify.com/s/files/1/0692/6358/9447/files/assorted-brownies-pack-of-4.jpg?v=1785599074&width=120',
      alt: 'Assorted Brownies'
    },
    'combos & hampers': {
      src: 'https://cdn.shopify.com/s/files/1/0692/6358/9447/files/assorted-brownies-pack-of-4.jpg?v=1785599074&width=120',
      alt: 'Assorted Brownies'
    },
    'occasions': {
      src: 'https://cdn.shopify.com/s/files/1/0692/6358/9447/files/birthday-truffle-poster-cake-500-gm.jpg?v=1785598832&width=120',
      alt: 'Celebration cake'
    },
    'new & trending': {
      src: 'https://cdn.shopify.com/s/files/1/0692/6358/9447/files/assorted-brownies-pack-of-4.jpg?v=1785599074&width=120',
      alt: 'Assorted Brownies'
    }
  };

  const titleOf = (item) => {
    const text = item.querySelector('.menu-drawer__menu-item-text');
    return (text?.textContent || '').trim().replace(/\s+/g, ' ').toLowerCase();
  };

  const addImage = (item, child = false) => {
    if (!(item instanceof HTMLElement) || item.querySelector(':scope > .devui-menu-thumb')) return;

    const imageData = menuImages[titleOf(item)];
    if (!imageData) return;

    const img = document.createElement('img');
    img.className = `devui-menu-thumb${child ? ' devui-menu-thumb--child' : ''}`;
    img.src = imageData.src;
    img.alt = imageData.alt;
    img.loading = 'lazy';
    img.decoding = 'async';
    img.width = child ? 29 : 42;
    img.height = child ? 29 : 42;

    const text = item.querySelector(':scope > .menu-drawer__menu-item-text');
    if (text) item.insertBefore(img, text);
  };

  const removeOldInjectedHeader = (root = document) => {
    root.querySelectorAll('.devui-drawer-brand, .devui-drawer-quick').forEach((node) => node.remove());
  };

  const enhanceDrawer = (drawer) => {
    removeOldInjectedHeader(drawer);

    const topLevelItems = drawer.querySelectorAll([
      ':scope > .menu-drawer__navigation > .menu-drawer__menu > li > a.menu-drawer__menu-item--mainlist',
      ':scope > .menu-drawer__navigation > .menu-drawer__menu > li > details > summary.menu-drawer__menu-item--mainlist',
      ':scope > .menu-drawer__navigation > .menu-drawer__menu > li > accordion-custom details > summary.menu-drawer__menu-item--mainlist'
    ].join(','));

    topLevelItems.forEach((item) => addImage(item, false));

    drawer.querySelectorAll('.menu-drawer__menu-item--child').forEach((item) => addImage(item, true));
  };

  const enhance = () => {
    removeOldInjectedHeader();
    if (!mobileQuery.matches) return;
    document.querySelectorAll('header-drawer .menu-drawer').forEach(enhanceDrawer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance, { once: true });
  } else {
    enhance();
  }

  document.addEventListener('shopify:section:load', enhance);
  document.addEventListener('shopify:section:reorder', enhance);

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', enhance);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(enhance);
  }

  /* Section hydration can replace drawer markup after initial load. Keep the
     enhancer idempotent and only observe long enough to catch that replacement. */
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      enhance();
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 15000);
})();
